$(function() {
	checkInputErrors();

	$('form').not('.debug, .novalidate').attr('novalidate', 'novalidate').on('submit fake-submit', function(e) {
		var $form = $(this);
		var $submit = $form.find('[type=submit]');
		var errorItems = [];

		$form.removeClass('has-errors');

		if (e.type === 'submit' && !$form.hasClass('no-loader')) {
			$submit.prop('disabled', true).addClass('loading');
		}

		$form.find('.form-required .input-error[data-error-default!=""]').each(function() {
			var $item   = $(this);
			var fields  = $(this).data('error-fields').split(',');

			$.each(fields, function(key, value) {
				var $field = $form.find('[name="' + value + '"], [name^="' + value + '["], [name^="form_fields[' + value + ']"]');

				if ($field.length === 0) {
					console.warn('Could not find field with name', value);
					return;
				}

				var type = $field.get(0).type;

				if (!$field.is(':visible')) {
					// Niet valideren als het veld niet eens zichtbaar is
					// Let op: Dit is een aanpassing die ook een update van custom-inputs.less vereist!
					return;
				}

				if ($form.hasClass('debug')) {
					return; // in debug mode niks client-side valideren
				}

				// Default checks
				switch (type) {
					default:
						if ($field.val() === '') {
							errorItems.push($item);
							return;
						}
						break;

					case 'checkbox':
					case 'radio':
						if ($field.filter(':checked').length === 0) {
							errorItems.push($item);
							return;
						}
				}

				// Additional checks
				if (type === 'email') {
					if (!/^.+@.+\..+$/.test($field.val())) {
						errorItems.push($item);
					}
				}

				// No errors found, remove the error
				$item.text('');
			});
		});

		if (errorItems.length > 0) {
			e.preventDefault();
			e.stopImmediatePropagation();

			$form.addClass('has-errors');

			$.each(errorItems, function(key, $errorItem) {
				$errorItem.html($(this).data('error-default'));
			});

			$submit.removeClass('loading');

			setTimeout(function() {
				$submit.prop('disabled', false);
			}, 2000);

		} else {
			setTimeout(function() {
				$submit.prop('disabled', false);
			}, 3000);
		}

		checkInputErrors();
	});
});

function checkInputErrors() {
	var $allErrors = $('.input-errors-all');
	var $errorForm = false;

	$('.input-error').each(function() {
		var field  = $(this).attr('data-error-name');
		var $group = $(this).closest('.form-group');

		if ($(this).text().trim() !== '') {
			$errorForm = $(this).closest('form');
			$allErrors.find('[data-error-name="' + field + '"]').remove(); // Hide error in form top error listing
			$group.addClass('form-error');
			$(this).removeClass('d-none');

		} else {
			$group.removeClass('form-error');
			$(this).addClass('d-none');
		}
	});

	if ($allErrors.text().trim() === '') {
		$allErrors.hide();
	} else {
		$allErrors.slideDown('fast');
		$errorForm = $allErrors.closest('form');
	}

	var $firstError = $('.input-error:not(.d-none):first');

	if ($errorForm) {
		// If the error is in a modal, open the modal
		if ($errorForm.closest('.modal').length > 0) {
			$errorForm.closest('.modal').modal();

		} else {
			var $element = $firstError.closest('.form-group');

			if ($element.length === 0) {
				$element = $firstError;
			}

			setTimeout(function() {
				smoothScrollToCenter($element, $element.outerHeight() / 2, 500);
			}, 500);
		}
	}
}
